import { SpeciesSearchScreen } from '@screens/SpeciesSearch/SpeciesSearchScreen';

export default function BoardEditReportSpeciesScreen(): React.ReactNode {
  return <SpeciesSearchScreen />;
}
